import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { RsvpComponent } from 'src/app/features/events/components/rsvp/rsvp.component';
import { DividerComponent } from "../../../../shared/components/divider/divider.component";
import { IconComponent } from "../../../../shared/components/icon/icon.component";

@Component({
  selector: 'app-logout-confirmation',
  standalone: true,
  templateUrl: './logout-confirmation.component.html',
  styleUrls: ['./logout-confirmation.component.scss'],
  imports: [IconComponent, DividerComponent]
})
export class LogoutConfirmationModalComponent {
  private readonly authService = inject(AuthService);
  public dialogRef = inject(MatDialogRef<RsvpComponent>)

  logout() {
    this.authService.logout();
    this.closeDialog();
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
